import { ReactElement } from 'react';

const loanDurationMapping: { [key: string]: string } = {
    few_months: 'a few months or ongoing',
    one_to_two_years: 'one to two years',
    three_plus_years: 'three plus years'
};

const loanDurationMappingDE: { [key: string | number]: string } = {
    few_months: 'kurzfristigen',
    12: 'kurzfristigen oder flexiblen',
    one_to_two_years: 'mittelfristigen',
    24: 'mittelfristigen',
    three_plus_years: 'langfristigen',
    60: 'langfristigen',
    ongoing: 'flexiblen'
};

const loanPurposeMappingDE: { [key: string]: ReactElement } = {
    stock_purchase: (
        <>
            <span className="font-reg">und</span> Warenbestand erhöhen
        </>
    ),
    bridging_loan: (
        <>
            <span className="font-reg">zur</span> Zwischenfinanzierung
        </>
    ),
    marketing: (
        <>
            <span className="font-reg">und</span> Marketing betreiben
        </>
    ),
    equipment_purchase: (
        <>
            <span className="font-reg">und</span> Maschinen erwerben
        </>
    ),
    pay_bill: (
        <>
            <span className="font-reg">und</span> Verbindlichkeiten begleichen
        </>
    ),
    refinancing_debt: (
        <>
            <span className="font-reg">und</span> Kredite umschulden
        </>
    ),
    other: (
        <>
            <span className="font-reg">und</span> Sonstige Verwendung
        </>
    )
};

const loanPurposeMapping: { [key: string]: string } = {
    stock_purchase: 'purchasing stock',
    pay_staff: 'paying wages',
    pay_bill: 'paying a bill',
    refinancing_debt: 'refinancing debt',
    growing_business: 'growing my business',
    supporting_cashflow: 'supporting cash flow',
    other: 'other purposes',
    no_specific_need: 'no specific need'
};

export const getLoanDurationMapping = (qualitative_duration: string) => {
    return loanDurationMapping[qualitative_duration];
};

export const getLoanDurationMappingDE = (loanDuration: string | number) => {
    return loanDurationMappingDE[loanDuration];
};

export const getLoanPurposeMapping = (purpose: string) => {
    return loanPurposeMapping[purpose];
};

export const getLoanPurposeMappingDE = (purpose: string) => {
    return loanPurposeMappingDE[purpose];
};
